// extracted by mini-css-extract-plugin
module.exports = {"heading":"buy-now-dialog_heading__J_o07","btn":"buy-now-dialog_btn__OsxTq"};